var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { style: { margin: "5px 0" } },
    [
      _c(
        "w-col",
        { attrs: { xs: "6", lg: "2" } },
        [
          _c("w-input-number", {
            attrs: {
              disabled: _vm.unitPriceDisabled,
              label: _vm.$ct("labels.unitPrice"),
              fancy: "",
              decimals: _vm.decimals,
            },
            on: {
              focus: function ($event) {
                _vm.currentFocus = "price/unit"
              },
              blur: function ($event) {
                _vm.currentFocus = ""
              },
            },
            model: {
              value: _vm.pricePerUnit,
              callback: function ($$v) {
                _vm.pricePerUnit = $$v
              },
              expression: "pricePerUnit",
            },
          }),
        ],
        1
      ),
      _vm.canSeeProfit
        ? _c(
            "w-col",
            { attrs: { xs: "6", lg: "2" } },
            [
              _c("w-input-number", {
                attrs: {
                  disabled: _vm.profitDisabled,
                  label: _vm.$ct("labels.profit"),
                  fancy: "",
                  decimals: _vm.decimals,
                },
                on: {
                  focus: function ($event) {
                    _vm.currentFocus = "profit"
                  },
                  blur: function ($event) {
                    _vm.currentFocus = ""
                  },
                },
                model: {
                  value: _vm.computedValues.profit,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValues, "profit", $$v)
                  },
                  expression: "computedValues.profit",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.canSeeProfit
        ? _c(
            "w-col",
            { attrs: { xs: "6", lg: "2" } },
            [
              _c("w-input-number", {
                attrs: {
                  disabled: _vm.profitPercentDisabled,
                  label: _vm.$ct("labels.profitPercent"),
                  fancy: "",
                },
                on: {
                  focus: function ($event) {
                    _vm.currentFocus = "profitPercent"
                  },
                  blur: function ($event) {
                    _vm.currentFocus = ""
                  },
                },
                model: {
                  value: _vm.computedValues.profitPercentage,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValues, "profitPercentage", $$v)
                  },
                  expression: "computedValues.profitPercentage",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { xs: "6", lg: "2" } },
        [
          _c("app-vat-select", {
            attrs: {
              "use-object": "",
              fancy: "",
              label: _vm.$ct("labels.vat"),
              "create-new-enabled": "",
            },
            model: {
              value: _vm.product.Vat,
              callback: function ($$v) {
                _vm.$set(_vm.product, "Vat", $$v)
              },
              expression: "product.Vat",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "6", lg: "2" } },
        [
          _c("w-input-number", {
            attrs: {
              disabled: _vm.brutoPriceDisabled,
              label: _vm.$ct("labels.brutoPrice"),
              fancy: "",
              decimals: _vm.decimals,
            },
            on: {
              focus: function ($event) {
                _vm.currentFocus = "bruto"
              },
              blur: function ($event) {
                _vm.currentFocus = ""
              },
            },
            model: {
              value: _vm.computedValues.bruto,
              callback: function ($$v) {
                _vm.$set(_vm.computedValues, "bruto", $$v)
              },
              expression: "computedValues.bruto",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }